import React, { useState, useMemo, useRef, useEffect } from "react";
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogActions,
  Button,
} from "@fluentui/react-components";
import "./style.css";
import DOMPurify from "dompurify";

interface ReactQuillComponentProps {
  value: string;
}

const ReactQuillComponent = ({ value }: ReactQuillComponentProps) => {
  const [open, setOpen] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const previewRef = useRef<HTMLDivElement>(null);
  const cleanedText = useMemo(() => DOMPurify.sanitize(value), [value]);

  useEffect(() => {
    const el = previewRef.current;
    if (el) {
      setIsOverflowing(el.scrollHeight > el.clientHeight + 1);
    }
  }, [cleanedText]);

  return (
    <>
      <div className="note-preview-wrapper">
        <div ref={previewRef} className="note_lineClamp">
          <div dangerouslySetInnerHTML={{ __html: cleanedText }} />
        </div>

        {isOverflowing && (
          <span className="view-more-link" onClick={() => setOpen(true)}>
            View more
          </span>
        )}
      </div>

      <Dialog open={open} onOpenChange={(_, data) => setOpen(data.open)}>
        <DialogSurface style={{ minHeight: "fit-content" }}>
          <DialogBody style={{ display: "flex", flexDirection: "column" }}>
            <div className="dialog_content">
              <div dangerouslySetInnerHTML={{ __html: cleanedText }} />
            </div>
          </DialogBody>

          <DialogActions>
            <Button appearance="secondary" onClick={() => setOpen(false)}>
              Close
            </Button>
          </DialogActions>
        </DialogSurface>
      </Dialog>
    </>
  );
};

export default ReactQuillComponent;
